import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import { getVideos, uploadVideo, createExternalVideo, deleteVideo } from "../../api/videoApi";
import { getImages, uploadImage, createExternalImage, deleteImage } from "../../api/imageApi";
import { getPdfs, uploadPdf, createExternalPdf, deletePdf } from "../../api/pdfApi";

const AdminTeam = () => {
  const [media, setMedia] = useState({ videos: [], images: [], pdfs: [] });
  const [loading, setLoading] = useState(true);
  const [newMedia, setNewMedia] = useState({ name: "", title: "", order: 1, url: "", file: null, isExternal: false });
  const category = "Our Team";
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchMedia = async () => {
  //     try {
  //       const videos = await getVideos(category);
  //       const images = await getImages(category);
  //       const pdfs = await getPdfs(category);

  //       setMedia({ videos, images, pdfs });
  //     } catch (error) {
  //       console.error("Error fetching media:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchMedia();
  // }, []);

  // useEffect(() => {
  //   const fetchMedia = async () => {
  //     try {
  //       const videos = await getVideos(category);
  //       const images = await getImages(category);
  //       const pdfs = await getPdfs(category);

  //       // images.sort((a, b) => a.order - b.order);
  //       setMedia({ videos, images, pdfs });
  //       setNewMedia((n) => ({ ...n, order: 1 }));
  //     } catch (error) {
  //       console.error("Error fetching media:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchMedia();
  // }, []);

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const videos = await getVideos(category);
        const images = await getImages(category);
        const pdfs = await getPdfs(category);

        images.sort((a, b) => a.order - b.order);
        // setMedia({ videos, images, pdfs });
        setMedia({ videos, images, pdfs });
        setNewMedia((n) => ({ ...n, order: 1 }));
      } catch (error) {
        console.error("Error fetching media:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);

  // const handleCreate = async () => {
  //   try {
  //     if (!newMedia.file || !newMedia.name || !newMedia.title) {
  //       alert("Please enter a name, and select an image.");
  //       return;
  //     }

  //     // Upload Image
  //     const formData = new FormData();
  //     formData.append("image", newMedia.file);
  //     formData.append("name", newMedia.name);
  //     formData.append("title", newMedia.title);
  //     formData.append("order", String(newMedia.order));
  //     formData.append("category", category);

  //     const uploadedImage = await uploadImage(formData, category);
  //     // imageUrl = uploadedImage.fileUrl;

  //     if (!uploadedImage || !uploadedImage._id) {
  //       alert("Image upload failed.");
  //       return;
  //     }

  //     // Update State with New Team Member
  //     // setMedia((prev) => ({
  //     //   ...prev,
  //     //   images: [...prev.images, { ...uploadedImage }],
  //     // }));

  //     // // This is BEFORE the order fix hopefully
  //     // const images = await getImages(category);
  //     // // images.sort((a, b) => a.order - b.order);
  //     // setMedia((prev) => ({ ...prev, images }));

  //     const images = await getImages(category);
  //     images.sort((a, b) => a.order - b.order);
  //     setMedia((prev) => ({ ...prev, images }));

  //     // Reset Form
  //     // setNewMedia({ name: "", title: "", bio: "", file: null });
  //     setNewMedia({
  //       name: "",
  //       title: "",
  //       order: 1,
  //       url: "",
  //       file: null,
  //       isExternal: false,
  //     });

  //   } catch (error) {
  //     console.error("❌ Error creating team member:", error);
  //   }
  // };

  const handleCreate = async () => {
    try {
      if (!newMedia.file || !newMedia.name || !newMedia.title) {
        alert("Please enter a name, and select an image.");
        return;
      }

      // Upload Image
      const formData = new FormData();
      formData.append("image", newMedia.file);
      formData.append("name", newMedia.name);
      formData.append("title", newMedia.title);
      formData.append("order", String(newMedia.order));
      formData.append("category", category);

      const uploadedImage = await uploadImage(formData, category);
      // imageUrl = uploadedImage.fileUrl;

      console.log(
        `→ Requested order: ${newMedia.order}`,
        `| Server saved order: ${uploadedImage.order}`,
        uploadedImage
      );
      

      if (!uploadedImage || !uploadedImage._id) {
        alert("Image upload failed.");
        return;
      }

      // Update State with New Team Member
      // setMedia((prev) => ({
      //   ...prev,
      //   images: [...prev.images, { ...uploadedImage }],
      // }));

      // // This is BEFORE the order fix hopefully
      // const images = await getImages(category);
      // // images.sort((a, b) => a.order - b.order);
      // setMedia((prev) => ({ ...prev, images }));

      const images = await getImages(category);
      images.sort((a, b) => a.order - b.order);
      setMedia((prev) => ({ ...prev, images }));

      // Reset Form
      // setNewMedia({ name: "", title: "", bio: "", file: null });
      setNewMedia({
        name: "",
        title: "",
        order: 1,
        url: "",
        file: null,
        isExternal: false,
      });

    } catch (error) {
      console.error("❌ Error creating team member:", error);
    }
  };

  // ✅ Handle Deleting an Image BEFORE Order fix
  // const handleDelete = async (id, type) => {
  //   try {
  //     if (type === "images") {
  //       await deleteImage(id);

  //       setMedia((prev) => ({
  //         ...prev,
  //         images: prev.images.filter((img) => img._id !== id),
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error deleting:", error);
  //   }
  // };

  const handleDelete = async (id, type) => {
    try {
      if (type !== "images") return;
  
      // 1) delete on the server
      await deleteImage(id);
  
      // 2) re-fetch ONLY the images for this category
      const images = await getImages(category);
  
      // 3) sort ascending by order
      images.sort((a, b) => a.order - b.order);
  
      // 4) update state (leaving videos & pdfs untouched)
      setMedia(prev => ({
        ...prev,
        images,
      }));
  
      // 5) (optional) log out to verify:
      console.log("🗑️ After delete, images are now:", images.map(i => i.order));
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };


  if (loading) return <p>Loading...</p>;


  return (
    <div className="container mx-auto p-6">
      {/* Back Button */}
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-3xl font-bold mb-6">Admin - Our Team</h1>

      {/* Upload Image */}
      <div className="mb-6 border p-4 rounded shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Add Team Member</h2>

        {/* <input
          type="text"
          placeholder="Team Member Name"
          value={newMedia.title}
          onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        /> */}

        <input
          type="text"
          placeholder="Team Member Name"
          value={newMedia.name}
          onChange={(e) => setNewMedia({ ...newMedia, name: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        />

        <input
          type="text"
          placeholder="Team Member Title"
          value={newMedia.title}
          onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        />

        {/* Position chooser */}
        <input
          type="number"
          min="1"
          max={media.images.length + 1}
          placeholder="Position (1, 2, …)"
          value={newMedia.order}
          onChange={(e) =>
            setNewMedia({ ...newMedia, order: Number(e.target.value) })
          }
          className="border rounded p-2 w-full mb-2"
        />

        <input
          type="file"
          onChange={(e) => setNewMedia({ ...newMedia, file: e.target.files[0] })}
          className="border rounded p-2 w-full mb-2"
        />

        <button onClick={() => handleCreate("images")} className="bg-green-500 text-white px-4 py-2 rounded">
          Add Team Member
        </button>
      </div>

      {/* Display Team Members */}
      <h2 className="text-2xl font-semibold mb-4">Team Members</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {media.images.map((image) => (
          <div key={image._id} className="bg-white rounded-lg shadow-lg p-4 text-center">
            <img
              className="w-full h-48 object-cover rounded-lg"
              src={(image.imageUrl || image.fileUrl).replace(/^https?:\/\/[^/]+/, '')}
              alt={image.title || "Team Member"}
              onError={(e) => (e.currentTarget.src = "/default-placeholder.jpg")}
            />

            {/* Team Member Name */}
            {/* <h3 className="text-lg font-semibold mt-4 text-gray-900 text-center">
              {image.title || "Unnamed Member"}
            </h3> */}

            <h3 className="text-lg font-semibold mt-4 text-gray-900 text-center">
              {image.name}
            </h3>

            <h3 className="text-md font-semibold mt-4 text-gray-600 text-center">
              {image.title || "Unnamed Member"}
            </h3>

            <button
              className="bg-red-500 text-white px-4 py-2 rounded mt-2"
              onClick={() => handleDelete(image._id, "images")}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );

};

export default AdminTeam;



